import { AlertCircle, Check, Loader2 } from 'lucide-react';
import type { AutoSaveState } from '../../lib/useAutoSave';

// Header-slot indicator for screens that auto-save instead of showing a
// Save button (see useAutoSave). Renders nothing until the first save.
export function AutoSaveStatus({ status, onRetry }: { status: AutoSaveState; onRetry?: () => void }) {
  if (status === 'idle') return null;

  if (status === 'saving') {
    return (
      <span className="flex items-center gap-1.5 text-sm text-black/50 dark:text-white/50">
        <Loader2 size={15} className="animate-spin" />
        Saving…
      </span>
    );
  }

  if (status === 'saved') {
    return (
      <span className="flex items-center gap-1.5 text-sm text-green-600 dark:text-green-400">
        <Check size={15} />
        Saved
      </span>
    );
  }

  return (
    <button
      type="button"
      onClick={onRetry}
      className="flex items-center gap-1.5 text-sm text-red-500 hover:underline"
    >
      <AlertCircle size={15} />
      Save failed – retry
    </button>
  );
}
